import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

const i18nNamespaces = [I18nNamespace.DIRECTORY, I18nNamespace.COMMON];

interface MarkPersonAsUnknownConfirmationModalProps {
    isOpen: boolean;
    tags: string[];
    isSubmitting?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function MarkPersonAsUnknownConfirmationModal({
    isOpen,
    tags,
    isSubmitting,
    onConfirm,
    onCancel,
}: MarkPersonAsUnknownConfirmationModalProps) {
    const { t } = useTranslation(i18nNamespaces);

    return (
        <Modal
            isOpen={isOpen}
            title={t('persons.markAsUnknown.confirmTitle')}
            description={t('persons.markAsUnknown.confirmDescription', {
                count: tags.length,
                tags: tags.join(', '),
            })}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={isSubmitting}
            submitText={t('persons.card.markAsUnknown')}
            size="small"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
            contentTestId="mark-person-unknown-confirm-modal"
            submitButtonTestId="mark-person-unknown-confirm-submit"
        />
    );
}
